import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { HttpService } from '../shared/services/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { ControllerService } from '../shared/services/controller.service';
import { StoreHelper } from '../shared/helpers/store.helper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component'; // Import modal component

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    standalone: false
})
export class ContentComponent implements OnInit {

  contents: any = [];

  dataSource: any;

  activeMenuId: number | null = null; // Track open menu
  menuTimeout: any;

  // Close menu on document click
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.activeMenuId = null;
  }

  toggleMenu(id: number, event: MouseEvent) {
    event.stopPropagation();
    if (this.activeMenuId === id) {
      this.activeMenuId = null;
    } else {
      this.activeMenuId = id;
    }
  }

  onMouseLeave() {
    this.menuTimeout = setTimeout(() => {
      this.activeMenuId = null;
    }, 150);
  }

  onMouseEnter(id) {
    if (this.activeMenuId !== id) return;

    if (this.menuTimeout) {
      clearTimeout(this.menuTimeout);
      this.menuTimeout = null;
    }
  }

  filterDebounce: any

  showTip = true

  content: any

  usingStencil = ''

  contentFilter = ''

  clientName = ''

  stencils: any[] = []


  displayedColumns = [];
  publishState: Map<number, 'loading' | 'success' | 'error'> = new Map();
  durationState: Map<number, 'loading' | 'error'> = new Map();
  @ViewChild(MatSort, { static: true }) sort: MatSort = new MatSort();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  pageSize = 10;
  pageSizeOptions = [10, 20, 50, 100, 500];

  clientId: any;
  clientParam = ''

  code: any;


  columnNames = [
    {
      id: 'id',
      value: 'ID',
    },
    {
      id: "active",
      value: "Active",
    },
    {
      id: 'code_count',
      value: 'Code Count'
    },
    {
      id: 'type',
      value: 'Type'
    },
    {
      id: 'version',
      value:'Version'
    },
    {
      id: "name",
      value: "Name",
    },
    {
      id: 'ts',
      value: 'Timestamp'
    },
    {
      id: 'duration',
      value: "Duration"
    },
    {
      id: 'publish',
      value: ''
    },
    {
      id: 'actions',
      value: 'Actions'
    },
  ];

  constructor(private httpService: HttpService, private route: ActivatedRoute, private router: Router, public controller: ControllerService,private modalService: NgbModal) {

  }

  async closeNewContent(){
    await this.fetchContent()
    this.content = null
  }
  newContent( ){
    this.content = {google_doc_id : '' }
  }

  goToGlobalSearch() {
    this.router.navigate(['content/global-search-replace']);
  }

  async openBootstrapModal(text) {

    try{

      const modalRef = this.modalService.open(DialogConfirmComponent, {
        windowClass: 'center-modal-window'
      });


      modalRef.componentInstance.message = text;

      const result = await modalRef.result

      return result
    }
    catch( e ){
      return false
    }

  }

  onPageSizeChange( event: Event ){
    const pageSize = Number((event.target as HTMLSelectElement).value)
    const previousPageIndex = this.paginator.pageIndex
    const startIndex = previousPageIndex * this.paginator.pageSize

    this.pageSize = pageSize
    this.paginator.pageIndex = Math.floor(startIndex / pageSize) || 0
    this.paginator.pageSize = pageSize
    this.paginator.page.emit({
      previousPageIndex,
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    })
  }

  filter( event ){

    if( this.filterDebounce ){
      window.clearTimeout( this.filterDebounce )
    }

    this.filterDebounce = window.setTimeout( () => {
      this.dataSource.filter = event.target.value.trim()
      this.controller.setContentFilter(event.target.value.trim())
    }, 250 )
  }


  hideTip() {
    StoreHelper.setObject('hideContentTip', true)
    this.showTip = false
  }

  skeletonRows: number[][] = [];
  loading = false;

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  async fetchContent(){
    this.loading = true;
    this.generateSkeletonRows();

    try {
      const contents : any = await this.httpService.postAsync('hcontent/listContent', {})

      this.contents = contents.map( (it) => {

        return {
          ...it,
          active: this.code && it.active_codes && it.active_codes.split(',').includes(this.code.code),
        }
      }).sort( (a,b) => {
        if( a.active && !b.active ){
          return -1
        }
        if( !a.active && b.active ){
          return 1
        }

        // If active status is the same (both active or both inactive), sort by type
        const typeScore = (type) => {
          if( type == 'training') return 3
          if( type == 'library') return 2
          if( type == 'email') return 1
          return 0
        }
        return typeScore(b.type) - typeScore(a.type)
      })

      this.dataSource.data = this.contents
    } finally {
      this.loading = false
    }
  }

  async toggleStencil( $event ){
    try {
      await this.httpService.postAsync('hcode/toggleStencil', {
        code: this.code.code,
        checked: $event.checked
      })

      await this.fetchCodes()
    } catch (e) {
      $event.source.checked = !$event.checked
      alert("Failed to update template setting, please try again.")
    }
  }


  async publishContent(element: any) {
    const id = element.hcontent_id;
    this.publishState.set(id, 'loading');
    try {
      const res: any = await this.httpService.postAsync('hcontent/publish', { hcontentId: id });
      if (res && res.success) {
        this.publishState.set(id, 'success');
        setTimeout(() => {
          element.unpublished = false;
          this.publishState.delete(id);
        }, 3000);
      } else {
        this.publishState.set(id, 'error');
      }
    } catch {
      this.publishState.set(id, 'error');
    }
  }

  async refreshDuration(element: any) {
    const id = element.hcontent_id;
    if (this.durationState.get(id) === 'loading') return;

    this.durationState.set(id, 'loading');
    try {
      const res: any = await this.httpService.postAsync('hcontent/refreshDuration', { hcontentId: id });
      if (res && typeof res.duration === 'number') {
        element.duration = res.duration;
        this.durationState.delete(id);
      } else {
        this.durationState.set(id, 'error');
      }
    } catch {
      this.durationState.set(id, 'error');
    }
  }

  async updateContent( updateHContentId  ){

    if( await this.openBootstrapModal("This will update the content for ALL CODES that use this content. Are you sure?") ){


      const googleDocId = this.contents.find( ({hcontent_id}) => updateHContentId == hcontent_id).google_doc_id

      const result : any = await this.httpService.postAsync('hcontent/updateContent', {hcontentId: updateHContentId, googleDocId})

      if( !result.success ){
        alert("Failed fetching content - status: " + result.status)
        return
      }

      await this.fetchContent()
    }
  }

  openSpreadsheet( googleDocId ){
    window.open(`https://docs.google.com/spreadsheets/d/${googleDocId}`, "_blank")
  }

  preview( googleDocId ){

    if( !googleDocId ){
      console.error("can't load empty google doc")
      return
    }


    this.controller.setPreviewing(false)

    this.router.navigate(['start'], {
      queryParamsHandling: 'merge',
      queryParams: {googleDocId}
    })
  }

  currentPreview( hcontentId ){
    if( !hcontentId ){
      console.error("invalid contentid")

      return
    }
    this.controller.setPreviewing(false)
    this.router.navigate(['start'], {
      queryParamsHandling: 'merge',
      queryParams: {hcontentId}
    })
  }

  async toggleIncludeContent( event, element: any ){

    const hcontentId = element.hcontent_id
    const name = element.name

    const include = event.checked

    const action = include ? `Add ${name} to code ` : `Remove ${name} from code `


    const agree = this.code.stencil ? await this.openBootstrapModal(`${action} ${this.code.code }?`) : true


    if( !agree ){
      event.source.checked = !include
      return
    }

    try {
      await this.httpService.postAsync("hcontent/toggleCode", { code: this.code.code, active:include, hcontentId} )
      element.active = include
    } catch (e) {
      event.source.checked = !include
      alert("Failed to update content, please try again.")
    }

  }


  async useTemplate( event ){

    const value = event.target.value
    const select = event.target

    if( this.code.use_stencil_id == null && value == 0 ){
      return
    }

    // Changing from one template to another?
    if( this.code.use_stencil_id != null ){
      if( !await this.openBootstrapModal("Are you sure you want to switch templates? This will overwrite the current content configuration.") ){
        // Revert selection logic
        for(let i=0; i<select.options.length; i++) {
          if(select.options[i].value == this.code.use_stencil_id) {
            select.selectedIndex = i;
            break;
          }
        }
        return
      }
    }

    const res:any = await this.httpService.postAsync("hcontent/applyStencil", {code: this.code.code, stencil: value})
    if( !res.success || res.count == 0 ){
      alert("Error updating code, please try again.")
      console.error(res.message)
      return
    }
    await this.fetchContent()
    await this.fetchCodes()

  }

  async fetchCodes(){
    const resp :any = await this.httpService.postAsync("hcode/listCodes", {clientId: this.clientId})
    const codes = resp.codes
    this.controller.setCodes( codes )
    if( this.code && this.code.code ){
      this.code = this.controller.getCode( this.code.code )
    }
  }

   async ngOnInit() {

    this.dataSource = new MatTableDataSource(this.contents);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    this.controller.setPreviewing(false)
    this.showTip = StoreHelper.getObject('hideContentTip') ? false : true
    this.controller.shiftContainerToTop()

    this.contentFilter = this.controller.getContentFilter()
    this.dataSource.filter = this.contentFilter



    this.route.url.subscribe( async (url) =>{


      if( this.controller.getClients().length == 0 ){

        const clients = await this.httpService.postAsync("hclient/listClients", {})

        this.controller.setClients( clients )

      }

      this.clientParam = url[1] && url[1].path
      this.clientId = this.controller.getClientId( url[1] ? url[1].path : '' )

      if( this.controller.getCodes().length == 0 ){
        await this.fetchCodes()
      }


      if( url[3] && url[3].path ){
        this.code = this.controller.getCode( url[3] && url[3].path )
      }

      this.clientName = this.controller.getClientName(this.clientId)

      const stencilsResponse: any = await this.httpService.getAsync('hcode/getStencils')
      if( this.code && stencilsResponse ){
        this.stencils = stencilsResponse.data
        const usingStencil = stencilsResponse.data.find( stencil => stencil.id == this.code.use_stencil_id )
        this.usingStencil = usingStencil ? usingStencil.description : ''
      }

      this.displayedColumns = this.columnNames.map(x => x.id);

      if( this.clientId < 0 ){
        // remove include
        this.displayedColumns.splice(1,1)
      }

      await this.fetchContent()




    })
  }

}
